/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForMsVmm extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForMsVmm");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForMsVmm.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForMsVmm>): ServiceAccountNativeDetailsForMsVmm {
        let obj = Object.assign(new ServiceAccountNativeDetailsForMsVmm(), model);
        ServiceAccountNativeDetailsForMsVmm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForMsVmm>): ServiceAccountNativeDetailsForMsVmm {
        if (!model) return null;
        return ServiceAccountNativeDetailsForMsVmm.newInstance(<ServiceAccountNativeDetailsForMsVmm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForMsVmm) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForMsVmm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForMsVmm): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForMsVmm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
